import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

import { SidebarLinkSecondaryProps } from '../types';

const SidebarLinkSecondary = ({ to, title, target = '_self', dataLocator }: SidebarLinkSecondaryProps) => {
    const { pathname } = useLocation();
    const isActive = pathname === to || pathname.startsWith(`${to}/`);

    return (
        <S.LinkSecondary href={to} target={target} rel="noopener noreferrer" data-locator={dataLocator}>
            <Text type="small-text" bold={isActive}>
                {title}
            </Text>
        </S.LinkSecondary>
    );
};

export default memo(SidebarLinkSecondary);
